module.exports = __webpack_public_path__ + "img/0S6A0114.f3170ff2.jpg";